// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"946eef2e609e97401afb","655":"7eacb36cf44e89852840"}[chunkId] + ".js";
};